var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarketActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1066 9.33412C27.8762 8.93494 27.5463 8.60229 27.1491 8.36861C26.7518 8.13493 26.3008 8.0082 25.84 8.00078H8.77329L7.99996 4.98745C7.92183 4.69657 7.74751 4.44071 7.5054 4.26154C7.26328 4.08238 6.96764 3.99047 6.66663 4.00078H3.99996C3.64634 4.00078 3.3072 4.14126 3.05715 4.39131C2.8071 4.64135 2.66663 4.98049 2.66663 5.33412C2.66663 5.68774 2.8071 6.02688 3.05715 6.27692C3.3072 6.52697 3.64634 6.66745 3.99996 6.66745H5.65329L9.33329 20.3475C9.41143 20.6383 9.58574 20.8942 9.82786 21.0734C10.07 21.2525 10.3656 21.3444 10.6666 21.3341H22.6666C22.9128 21.3334 23.1541 21.2645 23.3635 21.135C23.573 21.0056 23.7425 20.8207 23.8533 20.6008L28.2266 11.8541C28.4162 11.4568 28.5044 11.0187 28.4835 10.579C28.4625 10.1393 28.3331 9.71162 28.1066 9.33412ZM21.84 18.6674H11.68L9.50663 10.6674H25.84L21.84 18.6674Z",
    fill: "url(#paint0_linear_722_4520)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 28C11.1046 28 12 27.1046 12 26C12 24.8954 11.1046 24 10 24C8.89543 24 8 24.8954 8 26C8 27.1046 8.89543 28 10 28Z",
    fill: "#E87A46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3334 28C24.4379 28 25.3334 27.1046 25.3334 26C25.3334 24.8954 24.4379 24 23.3334 24C22.2288 24 21.3334 24.8954 21.3334 26C21.3334 27.1046 22.2288 28 23.3334 28Z",
    fill: "#E87A46"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_722_4520",
    x1: 28.4865,
    y1: 12.6675,
    x2: 2.66663,
    y2: 12.6675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B225F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E40E41"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketActive);
export default __webpack_public_path__ + "static/media/MarketActive.061410b1573f0b6a8c4e2afa4f941e4c.svg";
export { ForwardRef as ReactComponent };